import styled from "styled-components";
import { theme } from "../theme";

export const StyledSearchButton = styled.button`
	border: ${({ isWhite }) => (isWhite ? `1px solid ${theme.color.blue1}` : "0")};
	border-left: none;
	background: ${({ isWhite }) => (isWhite ? theme.color.white : theme.color.background)};
	display: flex;
	align-content: center;
	align-items: center;
	padding: 0.8rem 1.2rem 0.8rem 1rem;
	border-top-right-radius: 0.3rem;
	border-bottom-right-radius: 0.3rem;
	cursor: pointer;
	position: relative;
	&::before {
		position: absolute;
		left: 0;
		top: 50%;
		width: 0.1rem;
		height: 50%;
		background: #d8dcdf;
		content: "";
		transform: translate(0, -50%);
	}
`;
